import { DEFAULT_THEME } from "@mantine/core";

import { CustomTheme } from "./interface";

export const colors: CustomTheme["colors"] = {
  ...DEFAULT_THEME.colors,
  blue: [
    "#F0F4FC",
    "#D5E1FA",
    "#BACDF9",
    "#91AFF7",
    "#678FF5",
    "#4675F5",
    "#3664E6",
    "#2955E2",
    "#2348BB",
    "#1E3D9B",
  ],

  red: [
    "#FDE7EA",
    "#FBBCC3",
    "#F8919D",
    "#F56576",
    "#F33A50",
    "#F00F29",
    "#C00C21",
    "#900919",
    "#600611",
    "#300308",
  ],
  grey: [
    "#F8F8F9",
    "#F3F4F6",
    "#EAECEF",
    "#D3D6DC",
    "#9EA6B4",
    "#6F7687",
    "#525C6B",
    "#3F4959",
    "#2A3340",
    "#1D2330",
  ],

  gray: [
    "#F8F8F9",
    "#F2F4F6",
    "#EAECEF",
    "#D3D6DC",
    "#9EA6B4",
    "#6F7687",
    "#525C6B",
    "#3F4959",
    "#2A3340",
    "#1D2330",
  ],
  green: [
    "#E9F8F1",
    "#C7F0DB",
    "#A4E8C5",
    "#7FE0B0",
    "#5BDA9A",
    "#6EF6A8",
    "#2EB97A",
    "#26906A",
    "#1D6859",
    "#1B5635",
  ],
  violet: [
    "#f6ecff",
    "#e7d6fb",
    "#caabf1",
    "#ac7ce8",
    "#9354e0",
    "#833cdb",
    "#7b2eda",
    "#6921c2",
    "#5d1cae",
    "#501599",
  ],
};
